import { render } from "./RouteNavi.vue?vue&type=template&id=49a86cad&scoped=true"
import script from "./RouteNavi.vue?vue&type=script&lang=js"
export * from "./RouteNavi.vue?vue&type=script&lang=js"

import "./RouteNavi.vue?vue&type=style&index=0&id=49a86cad&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49a86cad"]])

export default __exports__